import { api } from "./http-client";
import { PromoCodeEvent, CreatePromoCodeEventDto, UpdatePromoCodeEventDto, PromoCode } from "../interfaces/promo-code-event.interface";

export const promoCodeEventsService = {
  list: async (page = 1, take = 20): Promise<{ data: PromoCodeEvent[]; meta: any }> => {
    const res = await api.request<any>({ url: "/admin/promo-code-events", method: "GET", params: { page, take } });
    return res.data;
  },

  create: async (dto: CreatePromoCodeEventDto): Promise<PromoCodeEvent> => {
    const res = await api.request<PromoCodeEvent>({ url: "/admin/promo-code-events", method: "POST", data: dto });
    return res.data;
  },

  update: async (id: string, dto: UpdatePromoCodeEventDto): Promise<PromoCodeEvent> => {
    const res = await api.request<PromoCodeEvent>({ url: `/admin/promo-code-events/${id}`, method: "PUT", data: dto });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/promo-code-events/${id}`, method: "DELETE" });
  },

  listCodes: async (eventId: string, page = 1, take = 50): Promise<{ data: PromoCode[]; meta: any }> => {
    const res = await api.request<any>({ url: `/admin/promo-code-events/${eventId}/codes`, method: "GET", params: { page, take } });
    return res.data;
  },

  generateCodes: async (eventId: string, count: number): Promise<{ generated: number }> => {
    const res = await api.request<{ generated: number }>({ url: `/admin/promo-code-events/${eventId}/generate`, method: "POST", data: { count } });
    return res.data;
  },
};
